export default __webpack_public_path__ + "static/media/support-smartworks.40096328.yaml";